// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__tp_G_","inline":"Card_inline__jhIMO","bed":"Card_bed__Ybz3h"};